var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { TabbedShowLayout, Tab, useGetOne, useQuery, CRUD_GET_ONE, } from 'react-admin';
import { useTranslate } from 'ra-core';
import get from 'lodash/get';
import { makeStyles } from '@material-ui/core/styles';
import { Show } from '../ui';
import { ENTITY_TYPE_API } from '../dataProvider/documents';
import { CurrentUserId } from '../dataProvider/userContexts';
import { isPublisher } from '../userContexts';
import { ApiOverview } from './ApiOverview';
import { ApiDocumentation } from './ApiDocumentation';
import { ApiSpecs } from './ApiSpecs';
export const ApiShow = props => {
    const _a = useStyles(props), { root: rootClassName } = _a, classes = __rest(_a, ["root"]);
    const { id } = props, rest = __rest(props, ["id"]);
    const { data: userContexts } = useGetOne('userContexts', CurrentUserId, {
        action: CRUD_GET_ONE,
    });
    const { data: apisPermissions } = useQuery({
        type: 'getPermissions',
        resource: 'apis',
        payload: { id },
    });
    return (React.createElement(Show, Object.assign({ className: rootClassName, classes: classes, title: React.createElement(ApiTitle, null), id: id }, rest),
        React.createElement(ApiShowTabs, { userIsPublisher: isPublisher(userContexts), userCanEdit: get(apisPermissions, 'canEdit', false), userCanDelete: get(apisPermissions, 'canEdit', false) })));
};
export const ApiShowTabs = props => {
    const translate = useTranslate();
    const { userIsPublisher, userCanEdit, userCanDelete } = props, rest = __rest(props, ["userIsPublisher", "userCanEdit", "userCanDelete"]);
    const showSpecs = !isSoapApi(props.record);
    return (React.createElement(TabbedShowLayout, Object.assign({}, rest),
        React.createElement(Tab, { label: translate('resources.apis.overview.title') },
            React.createElement(ApiOverview, { userIsPublisher: userIsPublisher })),
        showSpecs && (React.createElement(Tab, { label: translate('resources.apis.specification.title'), path: "spec" },
            React.createElement(ApiSpecs, null))),
        React.createElement(Tab, { label: translate('resources.apis.documentation.title'), path: "doc" },
            React.createElement(ApiDocumentation, { userCanEdit: userCanEdit, userCanDelete: userCanDelete, entityType: ENTITY_TYPE_API }))));
};
const ApiTitle = (_a) => {
    var { record } = _a, rest = __rest(_a, ["record"]);
    const classes = useTitleStyles(rest);
    if (!record) {
        return null;
    }
    return (React.createElement("div", { className: classes.root },
        React.createElement("span", { className: classes.title }, record.name)));
};
export const isSoapApi = record => {
    // The API type is defined as ssgServiceType in the API list page,
    // but as apiServiceType in the API show page.
    // The react-admin engine first renders the API show page with the data of the API list page
    // in order to improve the user experience.
    // So we need to test both names to avoid a visual glitch when rendering the Tabs.
    const type = get(record, 'apiServiceType', null) ||
        get(record, 'ssgServiceType', null);
    return type && type.toLowerCase() === 'soap';
};
// We don't need custom styles by default but this allows to
// easily customize styles in the theme file directly
const useStyles = makeStyles({
    root: {},
    card: {},
}, {
    name: 'Layer7ApiShow',
});
const useTitleStyles = makeStyles(theme => ({
    root: {},
    title: {},
}), {
    name: 'Layer7ApplicationTitle',
});
//# sourceMappingURL=ApiShow.js.map